import ProfilePage from 'src/latest/src/features/profile/ProfilePage';
import TeletherapyContainer from 'src/latest/src/features/teletherapy/TeletherapyContainer';
import { SuperAdminDashboard } from 'src/latest/src/features/super-admin';
import { PracticeAdmin } from 'src/latest/src/features/practice-admin';
import { Resources } from '../features/resources';

export const RouteConfig = {
  profilePage: {
    path: '/profile/:profileId',
    name: 'ProfilePage',
    component: ProfilePage,
  },
  teletherapy: {
    path: '/teletherapy/*',
    name: 'Teletherapy',
    component: TeletherapyContainer,
  },
  superAdmin: {
    path: '/super-admin/*',
    name: 'SuperAdmin',
    component: SuperAdminDashboard,
  },
  practiceAdmin: {
    path: '/practice-admin/*',
    name: 'PracticeAdmin',
    component: PracticeAdmin
  },
  resources : {
    path: '/resources/*',
    name: 'Resources',
    component: Resources
  }
};
